import { UntypedFormControl } from "@angular/forms";
import { FormlyFieldConfig } from "@ngx-formly/core";

export function datagridRequiredValidator(control: UntypedFormControl, field: FormlyFieldConfig, options: any): any {
  const model = field.model;
  if(model != null && Array.isArray(model) && model.length > 0){
    return null;
  }
  else{
    let errorMessage = field.validation.messages['datagridRequired'].toString();
    if (errorMessage === undefined || errorMessage === null || errorMessage === '') {
      errorMessage = `${field.props.label} required`;
    }

    return {
      datagridRequired: { message: errorMessage }
    };
  }
}